
import { useDispatch } from 'react-redux';
import {
    deleteSpots, getFlippingFlyer,
    savePageSpotsData
} from '../../../store';

import { useTypedSelector } from '../../../hooks/useTypeSelector';

import { FlyerEditorLeftMenu } from './leftMenu/FlyerEditorLeftMenu'
import { FlyerEditorContent } from './rightContent/FlyerEditorContent'

import './FlyerSpotsEditor.scss'
import React, {useEffect, useState} from "react";
import {
    addEventDataTypeListener,
    EVENT_DATA_TYPE_OPEN_PAGES_FLYER, EVENT_DATA_TYPE_UPLOAD_FILE_TYPE,
    removeEventTypeListener
} from "../../../globals/EventDispatcher";
import {CustomDataEvent} from "../../../globals/CustomDataEvent";
import {clearFlyersData} from "../../../store/actionCreators/flyersActionCreators";
import {setSelectedPageForTabs} from "../../../store/actionCreators/pagesActionCreators";
import {ActionType} from "../../../store/actionTypes";
import {
    getExcelFileWithCurrentDataForFramesData,
} from "../../../store/actionCreators/flippingFlyerActionCreators";
import {DeleteSpotsRequestDto, FlyerPageDto, UserDto} from "../../../dtos";
import StatusPopup, {StatusPopupType} from "../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../pages/getSetttingsForPopup";
import {changeSearchTermForUnlinkedPromotionsItems} from "../../../store/actionCreators/promotionsItemsCreators";

export const FlyerSpotsEditor = () => {

    // let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    let flayerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const flyersState = useTypedSelector((state) => state.flyers);
    const [selectedItemInMenu, setSelectedItemInMenu] = useState<{ file?: any, code?: string }>({});
    const [isModalPopup, changeModalStatus] = useState(false);


    const dispatch = useDispatch();


    const onSpotsFileSelected = (file: File) => {
        let flyerDto = flayerDetailsState!
        dispatch(savePageSpotsData(flyerDto.flyRecId!, file, flyerDto.flyLacRec!.lacCode!));
        // let flyerDto = flippingFlyerState.flyerDto!
        // dispatch(savePageSpotsData(flyerDto.flyRecId!, file, flyerDto.flyLacRec!.lacCode!));
    }
    const [isOpenPagesTab, openPagesTab] = useState<boolean>(false);

    useEffect(() => {
        if(flyersState.type === ActionType.CHANGE_FLYERS_STATE){
            if(isOpenPagesTab){
                try {
                    const data = {
                        pageNo: 0,
                        selectedTabNum: 1
                    }
                    dispatch(setSelectedPageForTabs(data));
                } catch (e) {

                }
            }
        }
    }, [flyersState])
    useEffect(() => {
        addEventDataTypeListener(EVENT_DATA_TYPE_OPEN_PAGES_FLYER, (data: CustomDataEvent) => {
            openPagesTab(data.data);
        })

        addEventDataTypeListener(EVENT_DATA_TYPE_UPLOAD_FILE_TYPE, (data: CustomDataEvent) => {
            setSelectedItemInMenu({
                file: data.data.files[0],
                code: data.data.code
            });
        })
        console.log('addPromosForUnlinkedPromotionsMenu');

        return () => {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            // dispatch(clearDataForUnlinkedPromotionsItemsMenu());
            if (flayerDetailsState.flyRecId !== 0 && userDto) {
                dispatch(getFlippingFlyer(flayerDetailsState.flyRecId))
                dispatch(clearFlyersData());
                dispatch(changeSearchTermForUnlinkedPromotionsItems({
                    searchTermForUnlinkedItems: '',
                    searchTermForUnlinkedPromotions: ''
                }))
                removeEventTypeListener(EVENT_DATA_TYPE_OPEN_PAGES_FLYER);
                removeEventTypeListener(EVENT_DATA_TYPE_UPLOAD_FILE_TYPE);
            }
        }

    }, []);

    useEffect(() => {
        let flyerDto = flayerDetailsState!
        switch (selectedItemInMenu.code) {

            // case 'UploadPromosFile':
            //     dispatch(savePagePromosData(flyerDto.flyRecId!, selectedItemInMenu.file, flyerDto.flyLacRec!.lacCode!));
            //     break;
            // case 'UploadItemsFile':
            //     dispatch(savePagePromoItemsData(flyerDto.flyRecId!, selectedItemInMenu.file, flyerDto.flyLacRec!.lacCode!));
            //     break;
            case 'UploadFramesExcel':
                dispatch(savePageSpotsData(flyerDto.flyRecId!, selectedItemInMenu.file, flyerDto.flyLacRec!.lacCode!));
                break;
            case 'DownloadFramesExcel':
                dispatch(getExcelFileWithCurrentDataForFramesData(flyerDto.flyRecId!, flyerDto.flyCaption));
                break;
            case 'DeleteAllFlyerFrames':
                changeModalStatus(true);
                break;
        }
    }, [selectedItemInMenu])

    const onDeleteFrames = () => {
        const deletedSpotsIds: number[] = [];
        flayerDetailsState.flyerPages.forEach((page: FlyerPageDto) => {
            page.flyerPageSpots?.forEach((spot) => {
                deletedSpotsIds.push(spot.fpsRecId!);
            })
        });
        let userDtoStr = localStorage.getItem("userDto");
        let userDto: UserDto = JSON.parse(userDtoStr!);

        let requestDto: DeleteSpotsRequestDto = {
            userId: userDto.userId,
            uiLanguageCultureCode: "en-US",
            spots: deletedSpotsIds,
        };
        dispatch(deleteSpots(requestDto));
        changeModalStatus(false);
    }

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: 'deleteFramesFromFlyer',
        confirmOnClick: {
            deleteFramesFromFlyer: onDeleteFrames
        }
    };

    let settingsForPopup = getSettingsForPopup(settings);

    return (
        <div className="flyer_spots_editor_container">
            <FlyerEditorLeftMenu 
                onSpotsFileSelected={onSpotsFileSelected}
            />

            <FlyerEditorContent 
                data={flayerDetailsState}
                // data={flippingFlyerState.flyerDto}
            />

            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={''}
                messages={[settingsForPopup.messages]}
                show={isModalPopup}
                handleClose={() => changeModalStatus(false)}
            />
            }

        </div>
    )
}